export const MESSAGE_EDITOR_MENU_OPTIONS = [
  'strong',
  'em',
  'link',
  'undo',
  'redo',
  'bulletList',
  'orderedList',
  'imageUpload',
  'code',
];

export const MESSAGE_SIGNATURE_EDITOR_MENU_OPTIONS = [
  'strong',
  'em',
  'link',
  'undo',
  'redo',
  'imageUpload',
];

export const ARTICLE_EDITOR_MENU_OPTIONS = [
  'strong',
  'em',
  'link',
  'undo',
  'redo',
  'bulletList',
  'orderedList',
  'h1',
  'h2',
  'h3',
  'imageUpload',
  'code',
];

export const MESSAGE_EDITOR_IMAGE_RESIZES = [
  {
    name: 'Tiny',
    height: '40px',
  },
  {
    name: 'Small',
    height: '160px',
  },
  {
    name: 'Medium',
    height: '320px',
  },
  {
    name: 'Large',
    height: '640px',
  },
  {
    name: 'Original',
    height: 'auto',
  },
];
